// extracted by mini-css-extract-plugin
export var cardSelected = "_gr-2";
export var image = "_gr-1";
export var table = "_gr-0";